const ApiRoutes = {
  POST_INVOICE: "/e-invoice/form-submission",
  GET_RECEIPT: "/e-invoice",
  VALIDATE_RECEIPT: "/e-invoice/validate-receipt",
};

export default ApiRoutes;
